import { DeviceDetectorService } from 'ngx-device-detector';

import { ServiceLocator } from './data/locator.service';

export class ResponsiveCommon {

	$deviceService: DeviceDetectorService;

	responsive: boolean;
	mobile: boolean;

	allowedSections: string[];

	showFilters: boolean = true;

	constructor() {
		this.$deviceService = ServiceLocator.injector.get(DeviceDetectorService);
		this.responsive = this.$deviceService.isMobile() || this.$deviceService.isTablet();
		this.mobile = this.$deviceService.isMobile();
		if (this.responsive) this.showFilters = false;
		this.setAllowedSection();
	}

	setAllowedSection() {
		this.allowedSections = [
			'section.dispatches',
			'section.deliveries',
			'section.parcels',
			'section.claims',
			'section.trips',
			'section.instructions',
			'section.vehicles',
			'section.controlroomrisk',
			'section.controlroomops',
		];
	}
}
